import Logo from './image0.png'
export default function Teams(){
    return(
            <div className='App'>
        <img src={Logo} className='logo' alt="logo" />
            <header className='App-header'>
<h1>Teams</h1>
        <h2>
        7U HIT SQUAD
        <li>-Coach "K" Kelley</li>
        <li>-Coach Steph</li>
        </h2>
        <h2>
8U
<li>-Coach Henry</li>
        </h2>
        <h2>
9U
<li>-Coach King</li>
<li>-Coach Bowders</li>
        </h2>
        <h2>
10U
<li>-Coach Doug</li>
<li>-Coach Wharton</li>
        </h2>
        <h2>
11U
<li>-Coach Rod</li>
<li>-Coach Steve</li>
<li>-Coach Kev</li>
        </h2>
        <h2>
12U
<li>-Head Coach TBD</li>
        </h2>
            </header>
    
        </div>)
}